import { twMerge } from "tailwind-merge";
import { PollinatorLogo } from "@themes/pollinator/ui/PollinatorLogo";
import { InnerContentFrame } from "@themes/pollinator/ui/InnerContentFrame";
import { Type } from "@themes/pollinator/ui/Type";

export type Props = {
  organizationName?: string;
  isInverted: boolean;
  /** Optional suffix to append to org name (e.g., "Admin") */
  suffix?: string;
};

export function InvitationHeader({ organizationName, isInverted, suffix }: Props) {
  return (
    <InnerContentFrame
      as="header"
      className={twMerge(
        "z-20 bg-brand-50 border-b border-brand-800 md:border-none md:justify-start md:w-full",
        isInverted && "bg-brand-800 border-brand-50 md:border-b"
      )}
      innerClassName="flex-row justify-between md:flex-col md:gap-2 md:items-start md:absolute md:top-2 md:left-2"
    >
      {isInverted ? (
        <>
          <PollinatorLogo size="sm" theme="light" />
        </>
      ) : (
        <>
          <PollinatorLogo size="sm" theme="light" className="hidden md:block" />
          <PollinatorLogo size="sm" theme="dark" className="block md:hidden" />
        </>
      )}
      {organizationName && (
        <Type
          variant="h5"
          className={twMerge(
            "text-brand-800 md:text-brand-100",
            isInverted && "text-brand-100"
          )}
        >
          {organizationName}
          {suffix && ` ${suffix}`}
        </Type>
      )}
    </InnerContentFrame>
  );
}

export default InvitationHeader;


